











































// Import vendors ----------------------------------------------------------------------------------
import { computed, defineComponent, nextTick, onMounted, ref, watch } from '@vue/composition-api';
// Import plugins ----------------------------------------------------------------------------------
import { usePodocoreModule } from '@/plugins/podocore';
// Import configurations ---------------------------------------------------------------------------
import { apiConfig } from '@/config/api.config';
// Import components -------------------------------------------------------------------------------
import CompositeDialog from '@/components/composite/CompositeDialog.vue';
import AlertError from '@/components/alerts/AlertError.vue';
import AlertSuccess from '@/components/alerts/AlertSuccess.vue';
import WorkspaceInviteForm from '@/components/workspace/WorkspaceInviteForm.vue';
// Import types ------------------------------------------------------------------------------------
import type { DialogId } from '@/plugins/podocore/modules/bus/bus.module';
import type { PropType } from '@vue/composition-api';
import type { WorkspaceEntity } from '@/plugins/podocore/repositories/workspaces.repository';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'DialogWorkspaceMemberInvite',
  props: {
    workspace: {
      type: Object as PropType<WorkspaceEntity>,
      required: true
    }
  },
  components: {
    CompositeDialog,
    AlertError,
    AlertSuccess,
    WorkspaceInviteForm
  },
  setup(properties) {
    const dialogId: DialogId = 'workspace-invite';
    const rDialog = ref<any>(null);

    const requestModule = usePodocoreModule('request');
    const busModule = usePodocoreModule('bus');

    const workspaceInviteMembersRequest = requestModule.useAuthenticatedRequest(
      `${apiConfig.default}/workspaces/${properties.workspace.cuid}/members/invite`,
      {
        axios: {
          method: 'POST'
        }
      }
    );

    onMounted(() => {
      watch(
        () => rDialog.value.displayContent,
        (value: boolean) => {
          if (!value) {
            workspaceInviteMembersRequest.cancel();

            nextTick(() => {
              workspaceInviteMembersRequest.clear();
            });
          }
        }
      );
    });

    function submitForm() {
      rDialog.value.$children[0].$children[0].$children[0].$children[1].submit();
    }

    function inviteWorkspaceMembers(data: any) {
      const redirect_uri = new URL(window.location.origin);

      redirect_uri.pathname = '/join-workspace';

      workspaceInviteMembersRequest.request({
        axios: {
          method: 'POST',
          data: {
            usersEmails: [data.email],
            redirectUrl: redirect_uri.href
          }
        }
      });
    }

    function closeDialog() {
      rDialog.value.close();
    }

    const isDisabled = computed(() => {
      return workspaceInviteMembersRequest.isPending.value;
    });

    const isSuccess = computed(() => {
      return !workspaceInviteMembersRequest.error.value && !!workspaceInviteMembersRequest.data.value;
    });

    watch(isSuccess, (value) => {
      if (value) {
        busModule.publish(
          busModule.events.workspaceMembersInvited({
            workspaceCuid: properties.workspace.cuid
          })
        );

        // closeDialog();
      }
    });

    return {
      // References
      rDialog,
      // Values
      dialogId,
      workspaceInviteMembersRequest,
      // Methods
      submitForm,
      inviteWorkspaceMembers,
      closeDialog,
      // Flags
      isDisabled,
      isSuccess
    };
  }
});
